import React, { useState } from "react";
import { Provider } from "react-redux";
import "./App.scss";
import { ReactAuthWrapper } from "@carrier-sce-sharedpackages/reactauthwrapper";
import appConfig from "./environment/environments";
import Main from "./screens/Main";
import store from "./reducers";
import { addLocaleData } from "react-intl";
import nl from "react-intl/locale-data/nl";
import en from "react-intl/locale-data/en";
import fr from "react-intl/locale-data/fr";
import de from "react-intl/locale-data/de";
import it from "react-intl/locale-data/it";
import ru from "react-intl/locale-data/ru";
import pl from "react-intl/locale-data/pl";
import tr from "react-intl/locale-data/tr";
import es from "react-intl/locale-data/es";
import zh from "react-intl/locale-data/zh";
import zht from "react-intl/locale-data/zh";
import pt from "react-intl/locale-data/pt";
import sv from "react-intl/locale-data/sv";
import ja from "react-intl/locale-data/ja";

addLocaleData([
  ...nl,
  ...en,
  ...fr,
  ...de,
  ...it,
  ...ru,
  ...pl,
  ...tr,
  ...zh,
  ...zht,
  ...es,
  ...pt,
  ...sv,
  ...ja,
]);

const App = () => {
  const [permission, setPermission] = useState(null);

  const authCallback = (data) => {
    setPermission(data);
  };

  return (
    <Provider store={store}>
      <ReactAuthWrapper
        appConfig={appConfig.loginConfig}
        getPermissions={authCallback}
      >
        <Main permission={permission} />
      </ReactAuthWrapper>
    </Provider>
  );
};

export default App;
